import { render, staticRenderFns } from "./LocalVersionBanner.vue?vue&type=template&id=1de3f884"
import script from "./LocalVersionBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./LocalVersionBanner.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports